module.exports = __webpack_public_path__ + "static/media/xrfmachine.4273790e.png";